import React from "react";
import EvidenceListView, { ListRow } from "./EvidenceListView";

const fyLabel = (id, financialYears) => financialYears.find((fy) => String(fy.id) === String(id))?.financial_year_value || "—";

const kpiLabel = (doc, reportingQuestionsMap) => {
  if (doc?.questionId == null) return "—";
  const q = reportingQuestionsMap[doc.questionId];
  return q?.title ?? q?.kpi_name ?? "—";
};

const COLUMNS = [
  { key: "name", label: "Name", flex: 1 },
  { key: "fy", label: "Financial Year", width: 130 },
  { key: "kpi", label: "Question", width: 220 },
  { key: "uploadedBy", label: "Uploaded By", width: 130 },
  { key: "files", label: "Files", width: 100 },
  { key: "chevron", label: "", width: 30 },
];

/**
 * Qualitative evidence — always already linked to an answer (attach-while-
 * saving only, no batch/"pending review" state), so no sub-tabs and no
 * Location/Sub-location/Period columns (business rule: qualitative doesn't
 * depend on any of them). No DocSense-derived status either — qualitative
 * documents are never parsed.
 */
const QualitativeEvidenceListView = ({ groups, financialYears, reportingQuestionsMap, isLoading, error, onRetry, onRowClick }) => (
  <EvidenceListView
    columns={COLUMNS}
    rows={groups}
    rowKey={(g) => g.key}
    isLoading={isLoading}
    error={error}
    onRetry={onRetry}
    emptyTitle="No qualitative evidence found"
    emptySub="Evidence attached while answering a qualitative question appears here."
    footer={<span>Showing {groups.length} entr{groups.length === 1 ? "y" : "ies"}</span>}
    renderRow={(group, index) => {
      const first = group.documents[0];
      return (
        <ListRow index={index} onClick={() => onRowClick(group)}>
          <div style={{ flex: 1, padding: "0 10px", minWidth: 0 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#1e293b", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {group.label}
            </div>
          </div>
          <div style={{ width: 130, padding: "0 10px", fontSize: 12, color: "#475569" }}>{fyLabel(first?.financialYearId, financialYears)}</div>
          <div style={{ width: 220, padding: "0 10px", fontSize: 12, color: "#475569", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={kpiLabel(first, reportingQuestionsMap)}>
            {kpiLabel(first, reportingQuestionsMap)}
          </div>
          <div style={{ width: 130, padding: "0 10px", fontSize: 12, color: "#475569", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {first?.uploadedByName || "—"}
          </div>
          <div style={{ width: 100, padding: "0 10px" }}>
            <span style={{ fontSize: 10, fontWeight: 700, padding: "3px 9px", borderRadius: 20, background: "#f1f5f9", color: "#475569" }}>
              {group.documentCount} file{group.documentCount === 1 ? "" : "s"}
            </span>
          </div>
          <div style={{ width: 30, display: "flex", justifyContent: "center" }}>
            <i className="fas fa-chevron-right" style={{ fontSize: 11, color: "#cbd5e1" }} />
          </div>
        </ListRow>
      );
    }}
  />
);

export default QualitativeEvidenceListView;
